import { LARGE_CARD_IMAGE_KEY, CARD_IMAGE_KEY } from '@config'
import { isArray } from '@helpers/utils.js'

// create accessible card image
export function extractCardImage(placeholder, large = false) {
  return function (resource) {
    resource.card_image =
      (resource.logo &&
        resource.logo[large ? LARGE_CARD_IMAGE_KEY : CARD_IMAGE_KEY]) ||
      placeholder

    return resource
  }
}

class Serializer {
  constructor({
    transformations = [],
    options = {},
    defaults = {},
    optionsTransformations = [],
  } = {}) {
    this.transformations = transformations
    this.options = options
    this.defaults = defaults
    this.optionsTransformations = optionsTransformations
  }

  transform(initialData) {
    if (initialData.data) {
      const dataCollection = [...initialData.data]
      const data = dataCollection
        .map((data, index, array) => this._transform(data, index, array))
        .filter((item) => item !== null)

      return {
        ...initialData,
        data,
      }
    } else {
      return this._transform(initialData)
    }
  }

  addTransformation(transformation) {
    if (isArray(transformation)) {
      this.transformations = transformation.concat(this.transformations)
    }
  }

  _transform(data, index, array) {
    let dataCopy = { ...data }
    let optionsCopy = { ...this.options }

    if (this.transformations.length > 0) {
      this.transformations.forEach((func) => {
        dataCopy = func.call(this, dataCopy, index, array)
      })
    }

    if (this.optionsTransformations.length > 0) {
      this.optionsTransformations.forEach((func) => {
        optionsCopy = func.call(this, optionsCopy, dataCopy)
      })
    }

    if (dataCopy) {
      return { ...optionsCopy, ...this.defaults, ...dataCopy }
    }

    return null
  }

  getNew(initialData) {
    return { ...this.options, ...this.defaults, ...initialData }
  }
}

export default Serializer
